import React from 'react';
import { Breadcrumbs } from './Breadcrumbs';
import { OnThisPage } from './OnThisPage';
interface Section {
  id: string;
  title: string;
}
interface DocPageLayoutProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  breadcrumbs?: {
    label: string;
    id?: string;
  }[];
  onNavigate?: (id: string) => void;
  sections?: Section[];
}
export function DocPageLayout({
  title,
  description,
  children,
  breadcrumbs,
  onNavigate,
  sections = []
}: DocPageLayoutProps) {
  return <div className="flex max-w-7xl mx-auto px-8 py-12" data-id="element-167">
      <div className="flex-1 min-w-0 max-w-4xl" data-id="element-168">
        {breadcrumbs && <Breadcrumbs items={breadcrumbs} onNavigate={onNavigate} data-id="element-169" />}

        <div className="mb-10 border-b border-gray-200 pb-8" data-id="element-170">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 tracking-tight" data-id="element-171">
            {title}
          </h1>
          {description && <p className="text-lg text-gray-600 leading-relaxed" data-id="element-172">
              {description}
            </p>}
        </div>
        <div className="prose prose-blue max-w-none prose-headings:font-bold prose-headings:tracking-tight prose-a:text-[#0B5FA5] prose-a:no-underline hover:prose-a:underline" data-id="element-173">
          {children}
        </div>
      </div>

      {sections.length > 0 && <OnThisPage sections={sections} data-id="element-174" />}
    </div>;
}